<template>
  <div class="marketing-email-form-verify">
    <h1 class="marketing-email-form-verify-title">{{$t('message.marketingGenerics.message.content')}}</h1>

    <marketing-email-form-verify-item :label="$t('message.email.message.emailName')"
                                      :value="item.title"
                                      :editable="!viewOnly"
                                      @edit="openConfigModal" />

    <marketing-email-form-verify-item :label="$t('message.email.message.subject')"
                                      :value="item.subject"
                                      :editable="!viewOnly"
                                      @edit="openConfigModal" />

    <marketing-email-form-verify-item :label="$t('message.email.message.emailContent')"
                                      :value="contentText"
                                      :editable="!viewOnly"
                                      @edit="goToContent" />

    <marketing-email-form-verify-item :editable="!viewOnly"
                                      :label="$t('message.marketingGenerics.message.testSubmission')"
                                      :value="$t('message.marketingGenerics.message.testSubmissionHint')"
                                      @edit="openTestModal" />

    <marketing-email-form-verify-item :label="$t('message.marketingGenerics.message.plainText')"
                                      :value="$t('message.marketingGenerics.message.plainTextHint')"
                                      :editable="!viewOnly" 
                                      @edit="openConfigModal"/>

    <template v-if="!item.isAutomationFlow">
      <h1 class="marketing-email-form-verify-title">{{$t('message.marketingGenerics.message.recipients')}}</h1>

      <marketing-email-form-verify-item :label="$t('message.marketingGenerics.message.recipients')"
                                        :value="formatedSendType"
                                        :editable="!viewOnly"
                                        @edit="goToRecipients" />

    </template>

    <h1 class="marketing-email-form-verify-title">{{$t('message.email.message.sender')}}</h1>

    <marketing-email-form-verify-item :label="$t('message.email.message.senderName')"
                                      :value="item.senderName"
                                      :editable="!viewOnly"
                                      @edit="openConfigModal" />

    <marketing-email-form-verify-item :label="$t('message.email.message.senderEmail')"
                                      :value="item.senderEmail"
                                      :editable="!viewOnly"
                                      @edit="openConfigModal" />

    <marketing-email-config-modal :showing.sync="showConfigModal"
                                  :item="item"
                                  @saved="onSaved" />

    <marketing-email-test v-model="showTestModal"
                          :item="item" />

  </div>
</template>

<script>
import MarketingEmailTest from "@components/modules/marketing/email/test/MarketingEmailTest";
import MarketingEmailConfigModal from "@components/modules/marketing/email/config/modal/MarketingEmailConfigModal";
import MarketingEmailFormVerifyItem from "@components/modules/marketing/email/form/verify/item/MarketingEmailFormVerifyItem";

export default {
  components: {
    MarketingEmailFormVerifyItem,
    MarketingEmailConfigModal,
    MarketingEmailTest,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    contentText() {
      return this.item.content
        ? this.$t('message.email.message.bodyIsFilledOut')
        : this.$t('message.email.message.bodyIsNotFilledOut');
    },
    formatedSendType() {
      return {
        ["EXTERNAL"]: this.$t('message.email.message.externalBase'),
        ["WHOLE_DATABASE"]: this.$t('message.email.message.wholeDatabase'),
        ["SIMPLE_SEGMENTED_LIST"]: this.$t('message.email.message.simpleSegmentedList'),
        ["CUSTOM_SEGMENTED_LIST"]: this.$t('message.email.message.customSegmentedList')
      }[this.item.sendType];
    },
  },

  mounted() {},

  methods: {
    openConfigModal() {
      this.showConfigModal = true;
    },
    closeConfigModal() {
      this.showConfigModal = false;
    },
    onSaved(item) {
      this.closeConfigModal();

      this.$emit("saved", item);
    },
    goToContent() {
      this.$router.push({
        path: `/marketing/email/editar/${this.item.id}/conteudo`,
      });
    },
    openTestModal() {
      this.showTestModal = true;
    },
    goToRecipients() {
      this.$router.push({
        path: `/marketing/email/editar/${this.item.id}/destinatarios`,
      });
    },
  },

  data() {
    return {
      showConfigModal: false,
      showTestModal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-form-verify {
  .marketing-email-form-verify-title {
    color: #707070;
    font-size: 24px;
    margin-bottom: 10px;
    margin-left: 50px;
  }
}
</style>

